import { constants as destinationConstants } from '@eb/destination-utils';

//filter the returned formats/categories against this list
export const topCategories = [
    destinationConstants.MUSIC_EVENTBRITE_CATEGORY,
    destinationConstants.FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    destinationConstants.BUSINESS_EVENTBRITE_CATEGORY,
    destinationConstants.FAMILY_EDUCATION_EVENTBRITE_CATEGORY,
    destinationConstants.HEALTH_EVENTBRITE_CATEGORY,
    destinationConstants.PERFORMING_EVENTBRITE_CATEGORY,
    destinationConstants.HOBBIES_EVENTBRITE_CATEGORY,
    destinationConstants.COMMUNITY_EVENTBRITE_CATEGORY,
];
export const topFormats = [destinationConstants.PARTY_EVENTBRITE_FORMAT];

//include topPrice if suggestedTags > 3 options
export const topPrice = ['free'];

//include dates on priority represented in this list
export const topDates = ['this_weekend'];

export const GA_SEARCH_REDIRECTION_CATEGORY = 'search-end-results-redirection';
